<div class="card-body">
    <div id="apex-gradient-donut-chart"></div>
</div>